import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { collection, getDocs } from 'firebase/firestore';
import { firestore } from '@breakroom-nx/apis';

const apiName = '[VIBE API]';
export const vibeAPI = createApi({
  reducerPath: 'vibeApi',
  keepUnusedDataFor: 3600,
  baseQuery: fakeBaseQuery<Error>(),
  tagTypes: ['Vibes', 'Moods'],
  endpoints: (builder) => ({
    getVibes: builder.query<{ title: string; icon?: string }[], void>({
      providesTags: ['Vibes'],
      async queryFn() {
        try {
          // console.info(`${apiName} Getting vibes`);
          const vibes: { title: string; icon?: string }[] = [];

          const vibesCollection = 'vibes';
          const vibesSnap = await getDocs(
            collection(firestore, vibesCollection)
          );

          const promises = vibesSnap.docs.map(async (doc) => {
            const documentData = doc.data();
            const deviceLanguage = 'en';
            const icon = 'icon';
            const vibe = {
              title: documentData[deviceLanguage],
              icon: documentData[icon],
            };

            vibes.push(vibe);
          });

          await Promise.all(promises);
          return { data: vibes };
        } catch (err) {
          // console.log(`${apiName} ERROR GETTING VIBES: ${err}`);
          throw new Error('Unable to get topics at this time');
        }
      },
    }),
    getMoods: builder.query<{ title: string; icon?: string }[], void>({
      providesTags: ['Moods'],
      async queryFn() {
        try {
          // console.info(`${apiName} Getting moods`);
          const moods: { title: string; icon?: string }[] = [];

          const moodsCollection = 'moods';
          const moodsSnap = await getDocs(
            collection(firestore, moodsCollection)
          );

          const promises = moodsSnap.docs.map(async (doc) => {
            const documentData = doc.data();
            const deviceLanguage = 'en';
            const icon = 'icon';
            const mood = {
              title: documentData[deviceLanguage],
              icon: documentData[icon],
            };

            moods.push(mood);
          });

          await Promise.all(promises);
          return { data: moods };
        } catch (err) {
          // console.log(`${apiName} ERROR GETTING MOODS: ${err}`);
          throw new Error('Unable to get moods at this time');
        }
      },
    }),
  }),
});

export const { useGetVibesQuery, useGetMoodsQuery } = vibeAPI;
